<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="followupHeader" class="page-name color-71aa3f">
                        Create Followup
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backshowfollowup">Back</button>
                </div>
                <div v-if="isDataEditable == true">
                    <div class="admin-page-content">
                        <form id="followupform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Followup Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Priority</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="priority"
                                                v-model="priority"
                                                id="priority" label="text"
                                                :options="priorityArr"
                                                :required="true"
                                                v-validate="'required'"
                                                ></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('priority')" class="help is-danger" v-if="errors.has('priority')"><font color="red">Priority is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Status</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="status"
                                                v-model="status"
                                                id="status" label="text"
                                                :options="statusArr"
                                                :required="true"
                                                :value="status"
                                                v-validate="'required'"
                                                ></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('status')" class="help is-danger" v-if="errors.has('status')"><font color="red">Status is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Customer</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select v-model="customer_id" @change="changedValue" name="customer_id"
                                                      label="text" :filterable="false" :options="customerArr"
                                                      @search="onSearch"
                                                      v-validate="'required'"
                                                      placeholder="Select Customer">
                                                <template slot="no-options">
                                                    Search Customers...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('customer_id')" class="help is-danger" v-if="errors.has('customer_id')"><font color="red">Customer is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Collector</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <span class="form-control">{{user_id.text}}</span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Subject</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="text" id="subject" name="subject" class="form-control"
                                                   placeholder="Enter Subject" v-model="subject" 
                                                   v-validate="'required'">
                                            <div class="requiredstar">*</div>
                                            <span v-if="errors.has('subject')" v-show="subject == ''" class="help is-danger"><font color="red">Subject is required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Due Date</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input type="date" id="due_date" name="due_date" class="form-control"
                                                   placeholder="Enter Date in MM/DD/YYYY" v-model="due_date"
                                                   v-validate="'required'">
                                            <div class="requiredstar">*</div>
                                            <span class="help is-danger" v-if="dueDateError"><font color="red">{{ dueDateError }}</font></span>
                                            <span v-show="errors.has('due_date')" class="help is-danger" v-if="errors.has('due_date')"><font color="red">Due Date is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-6 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label"><strong>Category</strong></div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <v-select
                                                name="category"
                                                v-model="category"
                                                id="category" label="text"
                                                :options="CategoryArr"
                                                :required="true"
                                                :value="category"
                                                v-validate="'required'"
                                                ></v-select>
                                            <div class="requiredstar">*</div>
                                            <span v-show="errors.has('category')" class="help is-danger" v-if="errors.has('category')"><font color="red">Category is Required</font></span>
                                        </div>    
                                    </div>
                                    <div class="col-12 forms-block">
                                        <div class="col-1point5 paddingleft0">
                                            <div class="form-label"><strong>Description</strong></div>
                                        </div>
                                        <div class="col-10point5 paddingleft0">
                                            <textarea name="description" id="description" rows="10"
                                                      class="form-control"
                                                      placeholder="Enter Description"
                                                      v-model="description"></textarea>
                                        </div>    
                                    </div>
                                    <div class="col-12 forms-block">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="col-12 paddingleft0">
                                            <input id="addFollowupBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddFollowup()">
                                            <!-- <button style="float: left" id="addCaseBtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="addCase">{{btn}}</button> -->
                                            <input id="addAndContinueFollowupBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddFollowup(flag='Save and Continue')">
                                            <input id="CancelFollowup" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backshowfollowup">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-if="isDataEditable == false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from "vue";
    import EventBus from "../event-bus";
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from "vee-validate";
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VeeValidate);
// import moment from 'moment'
    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    const Swal = require('sweetalert2');
    var segments = "";
    var contex;
    export default {
        name: "AddFollowup",
        components: {
            'app-footer': FrontFooter,
            flatPickr,
        },
        mixins: [SessioMixin],
        data() {
            return {
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                userName: "",
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerId: 0,
                created_by: "",
                updated_by: "",
                config: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y G:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i:S',
                    enableTime: true,
                    //locale: Hindi, // locale for this instance only          
                },
                priority: {value: "normal", text: "Normal"},
                status: {value: "open", text: "Open"},
                subject: "",
                description: "",

                priorityArr: [
                    {
                        value: "high",
                        text: "High"
                    },
                    {
                        value: "normal",
                        text: "Normal"
                    },
                    {
                        value: "low",
                        text: "Low"
                    }
                ],
                statusArr: [
                    {
                        value: "open",
                        text: "Open"
                    },
                    {
                        value: "in_progress",
                        text: "In Progress"
                    },
                    {
                        value: "closed",
                        text: "Closed"
                    }
                ],
                category:{value: "call/email", text: "Call/Email"},
                CategoryArr: [
                    { value: "collector_initial_contact", text: "Collector – Initial Contact" },
                    { value: "collector_follow_up", text: "Collector – Follow Up" },
                    { value: "collector_escalation_to_credit_manager", text: "Collector - Escalation to Credit Manager" },
                    { value: "credit_manager_initial_contact", text: "Credit Manager - Initial Contact" },
                    { value: "ops_branch_account_escalation", text: "OPS/Branch – Account Escalation" },
                    { value: "credit_manager_cod_warning", text: "Credit Manager – COD Warning" },
                    { value: "credit_manager_cod_notification", text: "Credit Manager – COD Notification" },
                    { value: "demand_letter_issued", text: "Demand Letter Issued" },
                    { value: "escalation_to_corporate_credit_manager", text: "Escalation to Corporate Credit Manager" },
                    { value: "account_adjustment", text: "Account Adjustment (Refund/Write Off/Offset)" },
                    { value: "broken_promise_to_pay", text: "Broken Promise to Pay" },
                    { value: "customer_inquiry", text: "Customer Inquiry" },
                    { value: "credit_balance_review", text: "Credit Balance Review" },
                    { value: "credit_override", text: "Credit Override" },
                    { value: "credit_application_requested", text: "Credit Application Requested" },
                    { value: "credit_limit_review_request", text: "Credit Limit Review Request" },
                    { value: "dnc_status", text: "DNC Status (AFDA, Legal, 3rd Party, etc.)" },
                    { value: "dispute", text: "Dispute" },
                    { value: "promise_to_pay", text: "Promise to Pay" },
                    { value: "rebill_request", text: "Rebill Request" },
                    { value: "treasury_notification", text: "Treasury Notification" },
                    { value: "not_responding", text: "Not Responding" },
                    { value: "paid", text: "Paid" },
                    { value: "terms_of_credit", text: "Terms Of Credit" },
                    { value: "other", text: "Other" }
                ],
                
                due_date: "",
                dueDateError: '',
                customer_id: "",
                options: "",
                customerArr: [],
                user_id: "",
                userArr: [],
                isDataEditable: true,
                loginID: ""
            };
        },
        watch: {
            customer_id: function (customer_id) {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[2] != 'update') {
                    if (typeof (customer_id) == "undefined" || customer_id == null) {
                        self.user_id = {value: '', text: ''};
                    } else {
                        if (customer_id == '') {
                            self.user_id = {value: '', text: ''};
                        } else {
                            $.ajax({
                                url: process.env.ROOT_API + "/get/customer/user",
                                type: "GET",
                                headers: {
                                    Accept: "application/json",
                                    "Access-Control-Allow-Origin": "*",
                                    Authorization: "Bearer " + localStorage.getItem("api_token"),
                                    "Access-Control-Allow-Headers":
                                            "Origin, Content-Type, Authorization,X-Requested-With",
                                    "Cache-Control": "no-cache"
                                },
                                data: {
                                    customer_id: customer_id.value
                                },
                                dataType: "json",
                                success: function (data) {
                                    if (customer_id.value) {
                                        self.user_id = {value: data[0].value, text: data[0].text};
                                        self.userArr = data;
                                    }
                                },
                                error: function (jqXHR, exception) {
                                    if (jqXHR.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        if (jqXHR.status == 401) {
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            self.$router.push("/login");
                                        }
                                        self.error = jqXHR.responseJSON.message;
                                    }
                                }
                            });
                        }
                    }
                }
            },
            due_date: {
                handler(newDate) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[2] != 'update') {
                        const newDateOnly = new Date(newDate).setHours(0, 0, 0, 0);
                        const currentDateOnly = new Date().setHours(0, 0, 0, 0);
                        
                        if (newDateOnly < currentDateOnly) {
                            this.dueDateError = 'The due date must be greater than the current date!';
                        } else {
                            this.dueDateError = '';
                        }
                    }
                },
            },
        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = localStorage.getItem("api_token");

            if (check != null) {
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            $(".removeActive").removeClass("active");
            if (segments[2] == 'update') {
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menufollowups").addClass("active");
                }
            } else {
                //console.log(segments[3]);
                if (segments[3] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menufollowups").addClass("active");
                }
            }

            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (segments[2] == 'update') {
                if (segments[3]) {
                    self.showLoader();
                    self.loadFollowup();
                    // $("#addAndContinueFollowupBtn").prop('disabled',true);
                    $("#addAndContinueFollowupBtn").hide();
                    $("#addFollowupBtn").val("Update");
                    $("#followupHeader").text("Edit Followup");
                }
            } else {
                if (segments[3] != 0) {
                    self.customerId = segments[3];
                    self.loadCustomeradd();
                }
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }
        },
        methods: {
            onDateChage(selectedDates, dateStr, instance) {
                var self = this;
                //console.log("Date Change Called : " + self.due_date);
            },
            onPickerClose() {
                var self = this;
                //console.log("Picker Close Called : " + self.due_date);
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_followup') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearch(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadCustomer(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadUser(loading, search, this);
                }
            },
            loadCustomer(loading, search, vm) {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.customerArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadCustomeradd() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customerArr = data;
                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadUser(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.userArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            backshowfollowup() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[2] == 'update') {
                    if (segments[4] != 0) {
                        self.$router.push("/customer/view/" + segments[4]);
                    } else {
                        self.$router.push("/followup/list");
                    }
                } else {
                    if (segments[3] != 0) {
                        self.$router.push("/customer/view/" + segments[3]);
                    } else {
                        self.$router.push("/followup/list");
                    }
                }
            },

            AddFollowup(flag) {
                var self = this;
                self.$validator.validate().then(result => {
                    if (result && self.dueDateError == '') {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        //console.log(segments[3]);
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                //console.log(segments[3]);
                                $("#addFollowupBtn").val("Updating ...");
                                $("#addFollowupBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelFollowup").prop("disabled", true);
                                Swal.fire(
                                    'Updated!',
                                    'Followup updated successfully.',
                                    'success'
                                )
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueFollowupBtn").val("Saving ...");
                                    $("#addAndContinueFollowupBtn").prop("disabled", true);
                                    $("#addFollowupBtn").prop("disabled", true);
                                    $("#CancelFollowup").prop("disabled", true);
                                } else {
                                    $("#addFollowupBtn").val("Saving ...");
                                    $("#addFollowupBtn").prop("disabled", true);
                                    $("#addAndContinueFollowupBtn").prop("disabled", true);
                                    $("#CancelFollowup").prop("disabled", true);
                                    Swal.fire(
                                        'Updated!',
                                        'Followup updated successfully.',
                                        'success'
                                    )
                                }
                            }
                        } else {
                            if (flag === "Save and Continue") {
                                $("#addAndContinueFollowupBtn").val("Saving ...");
                                $("#addAndContinueFollowupBtn").prop("disabled", true);
                                $("#addFollowupBtn").prop("disabled", true);
                                $("#CancelFollowup").prop("disabled", true);
                            } else {
                                $("#addFollowupBtn").val("Saving ...");
                                $("#addFollowupBtn").prop("disabled", true);
                                $("#addAndContinueFollowupBtn").prop("disabled", true);
                                $("#CancelFollowup").prop("disabled", true);
                                Swal.fire(
                                    'Added!',
                                    'Followup added successfully.',
                                    'success'
                                )
                            }
                        }

                        var fields = $("#followupform").serializeArray();
                        fields.push({name: "priority", value: self.priority.value});
                        fields.push({name: "status", value: self.status.value});
                        fields.push({name: "category", value: self.category.value});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        self.$validator.validateAll();
                        self.$validator.errors.clear();
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                fields.push({name: "id", value: segments[3]});
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/followup/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addFollowupBtn").val("Update");
                                        $("#addFollowupBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelFollowup").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueFollowupBtn").val("Save and Continue");
                                            $("#addAndContinueFollowupBtn").prop("disabled", false);
                                            $("#addFollowupBtn").prop("disabled", false);
                                            $("#CancelFollowup").prop("disabled", false);
                                        } else {
                                            $("#addFollowupBtn").val("Save");
                                            $("#addFollowupBtn").prop("disabled", false);
                                            $("#addAndContinueFollowupBtn").prop("disabled", false);
                                            $("#CancelFollowup").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueFollowupBtn").val("Save and Continue");
                                        $("#addAndContinueFollowupBtn").prop("disabled", false);
                                        $("#addFollowupBtn").prop("disabled", false);
                                        $("#CancelFollowup").prop("disabled", false);
                                    } else {
                                        $("#addFollowupBtn").val("Save");
                                        $("#addFollowupBtn").prop("disabled", false);
                                        $("#addAndContinueFollowupBtn").prop("disabled", false);
                                        $("#CancelFollowup").prop("disabled", false);
                                    }
                                }
                                if (data.status == "success") {
                                    // self.$router.push('/followup/list');

                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass("hide");
                                        $(".alert-success").parent().addClass("show");
                                        self.priority = {value: 'normal', text: "Normal"};
                                        self.status = {value: 'open', text: "Open"};
                                        self.category = {value: 'call/email', text: "Call/Email"};
                                        self.subject = '';
                                        self.description = '';
                                        self.due_date = null;
                                        self.customer_id = '';
                                        self.options = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        //$("#due_date").val("");
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.backshowfollowup();
                                    }
                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        $("#addFollowupBtn").val("Update");
                                        $("#addFollowupBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelFollowup").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueFollowupBtn").prop("disabled", false);
                                            $("#addAndContinueFollowupBtn").val("Save and Continue");
                                            $("#addFollowupBtn").prop("disabled", false);
                                            $("#CancelFollowup").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            self.priority = {value: 'normal', text: "Normal"};
                                            self.status = {value: 'open', text: "Open"};
                                            self.category = {value: 'call/email', text: "Call/Email"};
                                            self.subject = '';
                                            self.description = '';
                                            self.due_date = null;
                                            self.customer_id = '';
                                            self.options = '';
                                            self.user_id = '';
                                            self.customerArr = [];
                                            self.userArr = [];
                                            //$("#due_date").val("");
                                            if (segments[3] != 0) {
                                                self.customerId = segments[3];
                                                self.loadCustomeradd();
                                            }
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addFollowupBtn").val("Save");
                                            $("#addFollowupBtn").prop("disabled", false);
                                            $("#addAndContinueFollowupBtn").prop("disabled", true);
                                            $("#CancelFollowup").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }

                                        if (jqXHR.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (jqXHR.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueFollowupBtn").prop("disabled", false);
                                        $("#addAndContinueFollowupBtn").val("Save and Continue");
                                        $("#addFollowupBtn").prop("disabled", false);
                                        $("#CancelFollowup").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        self.priority = {value: 'normal', text: "Normal"};
                                        self.status = {value: 'open', text: "Open"};
                                        self.category = {value: 'call/email', text: "Call/Email"};
                                        self.subject = '';
                                        self.description = '';
                                        self.due_date = null;
                                        self.customer_id = '';
                                        self.options = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        //$("#due_date").val("");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addFollowupBtn").val("Save");
                                        $("#addFollowupBtn").prop("disabled", false);
                                        $("#addAndContinueFollowupBtn").prop("disabled", true);
                                        $("#CancelFollowup").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },
            loadFollowup() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/followup/" + segments[3],
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        if (data.content[0].created_by == self.loginID) {
                            self.priority = {
                                value: data.content[0].priority,
                                text: self.formatString(data.content[0].priority)
                            };
                            self.status = {
                                value: data.content[0].status,
                                text: self.formatString(data.content[0].status)
                            };
                            self.category = {
                                value: data.content[0].category,
                                text: self.formatString(data.content[0].category)
                            };

                            self.subject = data.content[0].subject;
                            self.description = data.content[0].description;
                            //$("#due_date").val(data.content[0].due_date);
                            self.due_date = data.content[0].due_date;
                            self.customer_id = {
                                value: data.content[0].cid,
                                text: data.content[0].first_name + " (" + data.content[0].cusid + ")"
                            };
                            self.user_id = {
                                value: data.content[0].uid,
                                text:
                                        data.content[0].user_firstname +
                                        " " +
                                        data.content[0].user_lastname/* +
                                         " - " +
                                         data.content[0].user_email*/
                            };
                            self.isDataEditable = true;
                        } else {
                            self.isDataEditable = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            formatString(data) {
                var self = this;
                var value = data;
                if (data != undefined && data.includes('_')){
                    var value = data.replace(/_/g, " ");
                }
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/followup/AddFollowup.vue